module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar fixed-top navbar-toggleable-sm bg-inverse navbar-inverse"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarText"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/",
      "tag": "li",
      "activeClass": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("In Theaters")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/popular",
      "tag": "li",
      "activeClass": "active"
    }
  }, [_c('a', [_vm._v("Popular")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/upcoming",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("Upcoming")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/top",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("Top Rated")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/login",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("Login")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarText",
      "aria-controls": "navbarText",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "movievuer.png",
      "width": "64px",
      "height": "45px",
      "alt": ""
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "16px",
      "margin-top": "20px",
      "font-size": "24px"
    }
  }, [_vm._v("MovieVuer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0746d28c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 829
// module chunks = 0